// ISP-107 — Wheel Palette on-hover disclaimer (pure, dependency-free helper).
//
// In the read-only Theme view (Wheel -> Design -> Theme) the palette swatches
// are rendered without a `handleSelectColor` handler, so they are NOT directly
// clickable. The on-hover tooltip therefore shows the hex value AND a short
// disclaimer telling the user where the color can actually be applied.
//
// In interactive contexts (ColorPopup / Segment color side pane) the swatch IS
// clickable, so only the hex value is shown.
export const buildSwatchTooltip = (hex, isClickable) => {
  const base = `Hex Color: ${hex}`;
  if (isClickable) return base;
  return `${base}\nTo use this color select it in the 'Segment Menu' or 'Content Block' side panes`;
};

export default buildSwatchTooltip;
